import {
	INewsAlertEntry,
	NewsAlertDisplayOn,
} from '../contentful/types/INewsAlertEntry';
import { AirportCodes } from '../types/airports';
import getMostRecentAlert from './getMostRecentAlert';

export const NewsAlertIdForAirportCodeMap: {
	[key in AirportCodes | 'gateway']: NewsAlertDisplayOn;
} = {
	[AirportCodes.IAH]: NewsAlertDisplayOn.IAH,
	[AirportCodes.HOU]: NewsAlertDisplayOn.HOU,
	[AirportCodes.EFD]: NewsAlertDisplayOn.EFD,
	[AirportCodes.Spaceport]: NewsAlertDisplayOn.Spaceport,
	[AirportCodes.Corporate]: NewsAlertDisplayOn.Corporate,
	'gateway': NewsAlertDisplayOn.Gateway,
};

export const getNewsAlertForCurrentAirport = (
	airportCode: AirportCodes | 'gateway',
	newsAlerts?: INewsAlertEntry[],
) => {
	const newsAlertsForCurrentAirport = newsAlerts?.filter((alert) =>
		alert.fields.displayOn?.includes(NewsAlertIdForAirportCodeMap[airportCode]),
	);

	// Only one alert can be shown at a time
	const newsAlert = getMostRecentAlert(newsAlertsForCurrentAirport);

	return newsAlert;
};
